/**
* @ngdoc directive
* @name Report Variant
*
* @description
  Company / store reports selector
*/

(function () {
  reportVariant.$inject = ["PATH", "$location", "$window", "userDataGAService"];
  app.directive('reportVariant', reportVariant);

  function reportVariant(PATH, $location, $window, userDataGAService) {
    controller.$inject = ["$scope"];
    return {
      replace: true,
      restrict: 'E',
      controller: controller,
      templateUrl: PATH.components + 'reportVariant/reportVariant.html'
    };

    function controller($scope) {
      var absUrl = $location.absUrl().toString();
      var states = ['/report', '/chart'];
      states.forEach(function (state) {
        if (absUrl.endsWith(state)) {
          absUrl = absUrl.substring(0, absUrl.length - state.length);
        }
      });
      $scope.variants = [{ name: 'Company Reports', value: '/companyreports' },
                         { name: 'Store Reports', value: '/reports' }];
      $scope.reportVariant = (absUrl.indexOf($scope.variants[0].value) > 0) ? $scope.variants[0].value : $scope.variants[1].value;

      $scope.changeReportVariant = function () {
        // Company Reports url = /companyreports/index.html#/dailysummary + '/' || /reports || /chart
        // Store Reports url = /reports/reports.html#/dailysummary
        var variantName;
        if ($scope.reportVariant === $scope.variants[0].value) {
          absUrl = absUrl.replace($scope.variants[1].value, $scope.variants[0].value);
          variantName = $scope.variants[0].name;
        } else {
          absUrl = absUrl.replace($scope.variants[0].value, $scope.variants[1].value);
          variantName = $scope.variants[1].name;
        }

        userDataGAService.sendGAEvent({
          eventCategory: 'Group by reports',
          eventAction: 'groupByReports',
          eventValue: variantName,
          additional: true
        });

        $window.location.href = absUrl;
      };
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/reportVariant/reportVariant.js